import * as commonConstants from '@inbox-demo-nx/constants';

export const APP_ID = '88D7A525-2412-4162-922B-61C2B685CDD2';

export const API_URL =
  'https://vzmhavdjm7.execute-api.us-west-2.amazonaws.com/stg/ondemand';

export const channelCustomTypes = {
  ...commonConstants.channelCustomTypes,
  driverSupport: 'driverSupport',
};

export enum BotUserId {
  NotificationBot = '_notification-bot',
  Kim = '_driver-kim',
  Robin = '_agent-robin',
  DriverSupport = '_driver-support-bot',
}

export const ONDEMAND_SCENARIO_VERSION = '0.0.5';
